import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import ElephantLogo from '../components/ElephantLogo';

export default function HomePage() {
  const { user } = useAuth();

  return (
    <div className="home-container">
      <div className="home-hero">
        <ElephantLogo size={120} />
        <h1 className="home-title">Krunk 🐘</h1>
        <p className="home-tagline">
          Vores lille hjørne af internettet — memes, quiz og debat for familien.
        </p>

        {!user && (
          <div className="home-cta">
            <Link to="/login" className="btn btn-primary btn-lg">Log ind</Link>
            <Link to="/signup" className="btn btn-outline btn-lg">Opret konto</Link>
          </div>
        )}
      </div>

      <div className="home-features">
        <Link to="/memes" className="feature-card">
          <span className="feature-icon">🎭</span>
          <h2>Memes</h2>
          <p>Del og upvote de bedste memes</p>
        </Link>
        <Link to="/quiz" className="feature-card">
          <span className="feature-icon">🧠</span>
          <h2>Quiz</h2>
          <p>Test din viden og kæmp om pladsen</p>
        </Link>
        <Link to="/forum" className="feature-card">
          <span className="feature-icon">💬</span>
          <h2>Forum</h2>
          <p>Diskuter alt under solen</p>
        </Link>
      </div>
    </div>
  );
}
